<template>
  <!--  http://localhost:8080/login#/pbr/project/detail?key=1448830355606962178-->
  <div class="wrap-box">
    <div class="wrap-box-left">
      <div class="table-top-box">
        <span class="fl left">{{ $t('label.project.detail.title') }}</span>
        <span class="fr right" @click="$router.back()">
          <Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />{{
            $t('buttons.back')
          }}
        </span>
        <span class="fr right div-xs-hidden" @click="exportDetail"><span class="word-png"></span>{{ $t('buttons.export')
          }}</span>
        <span class="fr right">
          <Icon color="#008bce" @click="editFavorite" :type="info.fav ? 'md-star' : 'md-star-outline'"
            style="font-size: 20px;" />
        </span>
      </div>
      <div>
        <h3 class="cp-title">{{ info.title | filterEmpty }}</h3>
        <p class="cp-intro" v-if="!isBidding">{{ info.desc | filterSymbol }}</p>
        <Tabs>
          <TabPane :label="$t('label.project.detail.basicInformation')">
            <!-- 招投标-基本信息 -->
            <description v-if="isBidding">
              <description-item :label="$t('label.project.detail.projectName')" :span="24" :value="info.title | filterEmpty"/>
              <description-item :label="$t('label.project.detail.countryOrRegion')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.country | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectIndustry')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.industry | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectDomain')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}"  :value="info.projectDomain | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectStage')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.state | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectType')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.category | filterEmpty"/>
              <description-item :label="$t('label.project.detail.demandBudget')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.demandBudget | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectBidPublishDate')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}":value="info.projectBidPublishDate | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectEndDate')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}":value="info.projectDeadline | filterEmpty"/>
              <description-item :label="$t('label.project.detail.bidType')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.biddingProjectType | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectContact')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.contactPerson | filterEmpty"/>
              <description-item :label="$t('label.project.detail.subsidiaryOrgan')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.contactOrg | filterEmpty"/>
              <description-item :label="$t('label.project.detail.position')" :spanMap="{lg: 8, md: 12, sm:12, xs: 24}" :value="info.contactPosition | filterEmpty"/>
              <description-item :label="$t('label.project.detail.contact')" :span="24" :value="info.contactWay | filterEmpty"/>
            </description>
            <description v-else>
              <description-item :label="$t('label.project.detail.projectName')" :span="24"
                :value="info.title | filterEmpty" />
              <description-item :label="$t('label.project.detail.countryOrRegion')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }" :value="info.country | filterEmpty" />
              <description-item :label="$t('label.project.detail.signDate')" :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="info.signDate | filterEmpty | filterTime(self)" />
              <description-item :label="$t('label.project.detail.updateDate')" :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }"
                :value="info.updateDate | filterEmpty" />
              <description-item :label="$t('label.project.detail.projectIndustry')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }" :value="info.industry | filterEmpty" />
              <description-item :label="$t('label.project.detail.projectStage')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }" :value="info.state | filterEmpty" />
              <description-item :label="$t('label.project.detail.constructionCycle')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }" :value="info.buildCycle | filterEmpty" />
              <description-item :label="$t('label.project.detail.projectType')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }" :value="info.category | filterEmpty" />
              <description-item :label="$t('label.project.detail.projectAmount')"
                :spanMap="{ lg: 8, md: 12, sm: 12, xs: 24 }" :value="info.investmentAmount | filterEmpty" />
              <description-item :label="$t('label.project.detail.contact')" :spanMap="{ lg: 8, md: 24, sm: 24, xs: 24 }"
                :value="contact | filterEmpty" />
              <description-item :label="$t('label.project.detail.owner')" :span="24"
                :value="info.owner | filterEmpty" />
              <description-item
                :label="$route.params.category == '基建类' ? $t('label.project.detail.constructionName') : $t('label.project.detail.enterpriseName')"
                :span="24">
                <template slot="content">
                  <template v-if="info.buildOrganization && info.buildOrganization.length > 0">
                    <el-link :underline="false" style="cursor: pointer; color: #409eff;"
                      v-for="(unit, index) in info.buildOrganization.split(';')" :key="index"
                      @click.prevent="gotoCompanyDetail(unit, index)">
                      {{ unit | filterEmpty }}
                      <Divider type="vertical"
                        v-if="info.buildOrganization && index < (info.buildOrganization.split(';').length - 1)" />
                    </el-link>
                  </template>
                  <span v-else>--</span>
                </template>
              </description-item>
            </description>
          </TabPane>
          <TabPane v-if="!isBidding" :label="tabLabel">
            <description v-if="info.categoryId == '1386926990054313986'">
              <description-item :label="$t('label.project.detail.planStartDate')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.infrastructureItem.conPlanStart | filterEmpty"/>
              <description-item :label="$t('label.project.detail.planEndDate')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.infrastructureItem.conPlanEnd | filterEmpty"/>
              <description-item :label="$t('label.project.detail.excutedMode')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.infrastructureItem.conLmplementWay | filterEmpty"/>
              <description-item :label="$t('label.project.detail.realityStartDate')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.infrastructureItem.conActualStart | filterEmpty"/>
              <description-item :label="$t('label.project.detail.realityEndDate')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.infrastructureItem.conActualEnd | filterEmpty"/>
              <description-item :label="$t('label.project.detail.projectConstructionCycle')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.infrastructureItem.realityBuildCycle | filterEmpty"/>
              <description-item :label="$t('label.project.detail.technicalStandard')" :spanMap="{lg: 24, md: 24, sm:24, xs: 24}"
                                :value="info.infrastructureItem.technicalStandard | filterEmpty"/>
            </description>
            <description v-else-if="info.categoryId == '1386926941169700865'">
              <description-item :label="$t('label.project.detail.financingSubject')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.financingSubject | filterEmpty"/>
              <description-item :label="$t('label.project.detail.financingPurpose')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.financingPurpose | filterEmpty"/>
              <description-item :label="$t('label.project.detail.investor')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.investor | filterEmpty"/>
              <description-item :label="$t('label.project.detail.finRevenueProfit')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.finRevenueProfit | filterEmpty"/>
              <description-item :label="$t('label.project.detail.finCurrentAssets')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.finCurrentAssets | filterEmpty"/>
              <description-item :label="$t('label.project.detail.finFinanceMoney')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.finFinanceMoney | filterEmpty"/>
              <description-item :label="$t('label.project.detail.finFinanceStage')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.finFinanceStage | filterEmpty"/>
              <description-item :label="$t('label.project.detail.finFinanceWay')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.investItem.finFinanceWay | filterEmpty"/>
            </description>
            <description v-else-if="info.categoryId == '1392440483281063938'">
              <description-item :label="$t('label.project.detail.importExportType')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.importExportType | filterEmpty"/>
              <description-item :label="$t('label.project.detail.startEndTime')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.startEndTime | filterEmpty"/>
              <description-item :label="$t('label.project.detail.currencySystem')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.currencySystem | filterEmpty"/>
              <description-item :label="$t('label.project.detail.tradingPartners')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.tradingPartners | filterEmpty"/>
              <description-item :label="$t('label.project.detail.tradeMode')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.tradeMode | filterEmpty"/>
              <description-item :label="$t('label.project.detail.placeRegistrationReceive')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.placeRegistrationReceive | filterEmpty"/>
              <description-item :label="$t('label.project.detail.customsCategory')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.customsCategory | filterEmpty"/>
              <description-item :label="$t('label.project.detail.shippingType')" :spanMap="{lg: 8, md: 24, sm:24, xs: 24}"
                                :value="info.tradeItem.shippingType | filterEmpty"/>
            </description>
          </TabPane>
          <TabPane :label="$t('label.project.detail.historyInformation')">
            <div style="max-height: 300px;margin-top:10px;overflow:auto;">
              <div class="timeline-item" v-for="(item, index) in historyModels" :key="index">
                <div class="timeline-item-node">
                  <span class="timeline-item-node-text">{{ item.createTime }}</span>
                </div>
                <div class="timeline-item-content">
                  <div class="timeline-item-circle-box">
                    <div class="timeline-item-out-circle">
                      <div class="timeline-item-in-circle" v-if="index === 0"></div>
                    </div>
                    <div class="timeline-item-line"></div>
                  </div>
                  <p class="timeline-item-detail" v-html="item.content" style="text-indent: 0;"></p>
                  <div class="timeline-item-tags" v-if="item.articleName">
                    {{$t('label.project.detail.relatedInformation')}}: <el-link :underline="false" @click="gotoInfoDetail(item)" style="cursor:pointer;vertical-align: top;color: #409EFF;">{{ item.articleName }}</el-link>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>
        </Tabs>
        <div v-if="!isBidding">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.mileStone') }}</div>
          <div class="project-process">
            <!--            TODO: 根据返回的数据判断状态和显示时间-->
            <div class="project-process-col">
              <div class="project-process-item" :class="milestonClass(0)">
                <p v-if="milestonIndexArray.includes(0)">{{
                    getMileStoneTime($t('label.project.detail.projectWinning'))
                  }}</p>
                <strong>{{ $t('label.project.detail.projectWinning') }}</strong>
              </div>
            </div>
            <div class="project-process-col">
              <div class="project-process-item" :class="milestonClass(1)">
                <p v-if="milestonIndexArray.includes(1)">{{
                    getMileStoneTime($t('label.project.detail.projectSigning'))
                  }}</p>
                <strong>{{ $t('label.project.detail.projectSigning') }}</strong>
              </div>
            </div>
            <div class="project-process-col">
              <div class="project-process-item" :class="milestonClass(2)">
                <p v-if="milestonIndexArray.includes(2)">{{
                    getMileStoneTime($t('label.project.detail.projectStarted'))
                  }}</p>
                <strong>{{ $t('label.project.detail.projectStarted') }}</strong>
              </div>
            </div>
            <div class="project-process-col">
              <div class="project-process-item" :class="milestonClass(3)">
                <p v-if="milestonIndexArray.includes(3)">{{
                    getMileStoneTime($t('label.project.detail.stageAcceptance'))
                  }}</p>
                <strong>{{ $t('label.project.detail.stageAcceptance') }}</strong>
              </div>
            </div>
            <div class="project-process-col">
              <div class="project-process-item" :class="milestonClass(4)">
                <p v-if="milestonIndexArray.includes(4)">
                  {{ getMileStoneTime($t('label.project.detail.projectCompletion')) }}</p>
                <strong>{{ $t('label.project.detail.projectCompletion') }}</strong>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isBidding">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.projectAtlas') }}</div>
          <div style="height: 200px;display: flex;">
            <div style="display: flex;flex:1;flex-direction: column;">
              <pbr-atlas-analysis id="graphCompanyData" :graph="graphCompanyData"></pbr-atlas-analysis>
              <div style="text-align: center;font-weight: 700;">{{
                  $t('label.project.detail.relatedEnterprises')
                }}
              </div>
            </div>
            <div style="display: flex;flex:1;flex-direction: column;">
              <pbr-atlas-analysis v-if="graphIndustryData" id="graphIndustryData"
                                  :graph="graphIndustryData"></pbr-atlas-analysis>
              <div style="text-align: center;font-weight: 700;">{{ $t('label.project.detail.relatedIndustries') }}</div>
            </div>
            <div style="display: flex;flex:1;flex-direction: column;">
              <pbr-atlas-analysis key="3" v-if="graphProjectData" id="graphProjectData"
                                  :graph="graphProjectData"></pbr-atlas-analysis>
              <div style="text-align: center;font-weight: 700;">{{ $t('label.project.detail.relatedProjects') }}</div>
            </div>


          </div>
        </div>
        <!-- 招投标-项目概述 -->
        <div v-if="isBidding&&info.desc">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.projectBrief') }}</div>
          <div class="project-brief" v-html="info.desc"> </div>
        </div>
        <!-- 招投标-项目内容 -->
        <div v-if="isBidding&&info.content">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.title') }}</div>
          <div class="project-brief" v-html="info.content"></div>
        </div>
        <div style="position:relative;" v-if="!isBidding">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.relevantRiskEvents') }}</div>
          <div class="related-risk-box" ref="relatedRisk">
            <div class="related-risk-item" v-for="(risk, index) in (showAllRisk ? riskAllModels : riskModels)" :key="index">
              <el-link :underline="false" @click="gotoRisk(risk.name)"
                       class="related-risk-text">
                <p>{{risk.num}}</p>
                <p>{{ risk.name }}</p>
              </el-link>
            </div>
            <i ref="relatedRiskFoldIcon" :class="foldIcon" class="related-risk-box-fold-icon"
               @click="riskFold"></i>
          </div>
        </div>
        <div v-if="info.country && info.country.indexOf('****') < 0" v-show="!isEN">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.countryRelatedInformation') }}</div>
          <div class="related-risk-box">

            <a :href="`#/nationalCityTopics/${this.info.countryEn}`" target="_blank">
              <Avatar shape="square" :src="info.flag" icon="md-flag" size="large"/>
              {{ info.country }}
            </a>
          </div>
        </div>
        <div v-if="lawModels.length > 0">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.relevantNationalLaws') }}</div>
          <div class="related-risk-box">
            <template v-for="(law,index) in lawModels">
              <el-link :underline="false" :key="index" @click="()=>{copyToPasteBoard(law.path)}" target="_blank">《{{ law.name }}》</el-link>
              <Divider type="vertical" v-if="index < (lawModels.length - 1)"/>
            </template>

            <!--            <div class="related-risk-item">-->
            <!--              <img class="related-risk-img" src="../common/img/PDF.png" alt="">-->
            <!--              <div class="legal-risk-text">-->
            <!--                <p>哈萨克斯坦海关事务法</p>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <div v-if="policies.length > 0">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.policiesAndRegulations') }}</div>
          <div class="related-risk-box">
            <template v-for="(policie,index) in policies">
              <el-link :underline="false" :key="index" @click="()=>{copyToPasteBoard(policie.path)}" target="_blank">《{{ policie.name }}》</el-link>
              <Divider type="vertical" v-if="index < (policies.length - 1)"/>
            </template>

          </div>
        </div>
        <div v-if="websites.length > 0">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.commonWebsiteLinks') }}</div>
          <div class="related-risk-box">
            <template v-for="(website,index) in websites">
              <el-link :underline="false" :key="index" @click="()=>{copyToPasteBoard(website.path)}" target="_blank">《{{ website.name }}》</el-link>
              <Divider type="vertical" v-if="index < (websites.length - 1)"/>
            </template>

          </div>
        </div>
        <div v-if="info.projectFiles && info.projectFiles.length > 0">
          <div class="pbr-title mt15 mb15">{{ $t('label.project.detail.projectAttachments') }}</div>
          <div class="related-risk-box project-attachments-box">
            <template v-for="(file, index) in info.projectFiles">
              <el-link
                :underline="false"
                :key="index"
                :href="getProjectFileUrl(file)"
                target="_blank"
              >{{ file.name | filterEmpty }}</el-link>
              <Divider type="vertical" v-if="index < (info.projectFiles.length - 1)"/>
            </template>
          </div>
        </div>
        
        <div class="project-disclaimer">
          <div class="project-disclaimer-title">{{ $t('label.project.detail.disclaimer') }}</div>
          <div class="project-disclaimer-content">{{ $t('label.project.detail.disclaimerContent') }}</div>
        </div>
        <div class="project-detail-contact-hint">
          {{ $t('label.project.detail.contactHint') }}
        </div>
      </div>
    </div>
    <div class="wrap-box-right">
      <div>
        <div class="pbr-title">{{ $t('label.project.detail.relevantInformation') }}</div>
        <normal-list :data="articleModels" :isBidding="isBidding" :page-size="10" goto="pbrInfoDetail"></normal-list>
      </div>
      <div>
        <div class="pbr-title">{{ $t('label.project.detail.relatedBusinessOpportunities') }}</div>
        <normal-list :data="businessModels" :isBidding="isBidding" :page-size="10" goto="pbrBusinessDetail"></normal-list>
      </div>
    </div>
    <div v-show="false" ref="submitForm">
      <form
          method="get"
          target="_blank"
          enctype="multipart/form-data"
          :action="action"
      >
        <input name="id" type="text"/>
        <input name="from" type="text" value="cn"/>
      </form>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import NormalList from '../index/NormalList.vue'
import Description from '../components/ElDescription.vue'
import DescriptionItem from '../components/ElDescriptionItem.vue'
import PbrAtlasAnalysis from '../analysis/AtlasAnalysis'
import {contentType, exportFile} from '../apis/common'

const MileStoneNameSort = ['项目中标', '合同签订', '项目开工', '阶段验收', '项目竣工']
const MileStoneValueSort = ['ProjectWinning', 'ContractSigning', 'ProjectStarts', 'StageAcceptance', 'ProjectCompletion']
const riskCNModels = [{name: '外部政治风险', num:0}, {name: '主权政治风险', num:0}, {name: '社会动荡风险', num:0}, {name: '对华关系风险', num:0}, {name: '资金风险', num:0}, {name: '财政风险', num:0}, {name: '通货膨胀风险', num:0}, {name: '汇率风险', num:0}, {name: '环保风险', num:0}, {name: '法律风险', num:0}, {name: '突发事件风险', num:0}, {name: '项目实施风险', num:0}, {name: '企业风险', num:0}, {name: '其他风险', num:0}]
const riskENModels = [{name: 'External Political Risks', num:0}, {name: 'Sovereign Political Risks', num:0}, {name: 'Risk of Social Unrest', num:0}, {name: 'Risk of Relations with China', num:0}, {name: 'Capital Risks', num:0}, {name: 'Financial Risks', num:0}, {name: 'Inflation Risks', num:0}, {name: 'Exchange-rate Riskss', num:0}, {name: 'Environmental Risks', num:0}, {name: 'Legal Risks', num:0}, {name: 'Emergency Risks', num:0}, {name: 'Project Implementation Risks', num:0}, {name: 'Enterprise Risks', num:0}, {name: 'Other Risks', num:0}]
export default {
  name: 'pbrProjectDetail',
  inject:['copyToPasteBoard'],
  components: {
    PbrAtlasAnalysis,
    NormalList,
    Description,
    DescriptionItem
  },
  data () {
    let that = this
    return {
      self: this,
      questionVisible: false,
      graphCompanyData: {
        graph: {}
      },
      graphIndustryData: {
        graph: {}
      },
      graphProjectData: {
        graph: {}
      },
      info: {},
      contact:'',
      historyModels: [],
      milestonModels: [],
      adviseModels: [],
      lawModels: [],
      policies: [],
      websites: [],
      reportModels: [],
      countryRiskModels: [],
      businessModels: [],
      articleModels: [],
      riskModels: [],
      tableData: [],
      action: this.$pbrApis.exportProjectDetailWordUrl,
      foldIcon: 'el-icon-d-arrow-right',
      showAllRisk: false,
      isBidding: false,//是否是招标项目
    }
  },
  computed: {
    isEN () {
      return localStorage.getItem('locale') === 'en'
    },
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    tabLabel(){
      switch (this.info.categoryId) {
        case '1386926990054313986':
          return this.$t('label.project.detail.constructionInformation')
        case '1386926941169700865':
          return this.$t('label.project.detail.investmentInformation')
        case '1392440483281063938':
          return this.$t('label.project.detail.tradeInformation')
        default:
          return this.$t('label.project.detail.otherInformation')
      }
    },
    mileStoneSort () {
      return localStorage.getItem('locale') === 'en' ? MileStoneValueSort : MileStoneNameSort
    },
    milestonIndexArray () {
      let arr = []
      this.milestonModels.forEach(m => {
        let idx = this.mileStoneSort.findIndex(n => n === m.event)
        arr.push(idx)
      })
      return arr
    },
    riskModelsNameArray () {
      return this.riskModels.map(r => r.name)
    },
    riskModelNameWithValueArray () {
      return this.riskModels.filter(r => r.num).map(r => r.name)
    },
    riskAllModels () {
      let models = eval(`risk${localStorage.getItem('locale').toUpperCase()}Models`).concat([])
      this.riskModels.forEach((r) =>{
        let idx = models.findIndex(m => m.name === r.name)
        models[idx] = r
      })
      return models
    },
    maxMilestonIndex () {
      let arr = this.milestonIndexArray
      if (arr.length > 0) {
        return Math.max(...arr)
      }
      return -1
    }
  },
  created () {

  },
  mounted () {
    console.log(this.$route)
    this.$nextTick(() => {

    })
  },
  activated () {
    this.info = {}
    this.graphCompanyData.graph = {}
    this.graphIndustryData.graph = {}
    this.graphProjectData.graph = {}
    this.showAllRisk = false
    this.foldIcon = 'el-icon-d-arrow-right'
    if (this.$route.query.key) {
      this.fetchProjectDetail()
      this.fetchProjectReferensInfo()
      this.fetchProjectReferensOthers()
      this.getGraphIndustryData()
      this.getGraphCompanyData()
      this.getGraphProjectData()
    } else {
      // this.$iMessage.error({
      //   content: this.$t('message.warning.noId'), duration: 5, onClose: () => {
      //     this.$router.replace({name: 'pbrProject'})
      //   }
      // })

    }
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.$refs.questionIcon.click()
    //   }, 1000)
    // })
  },
  methods: {
    riskFold () {
      this.showAllRisk = !this.showAllRisk
      this.foldIcon = this.showAllRisk ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'
      // if (this.$refs.relatedRisk.classList.contains('related-risk-box-hidden')){
      //   this.$refs.relatedRisk.classList.remove('related-risk-box-hidden')
      //
      //   this.foldIcon = 'el-icon-d-arrow-left'
      //   this.$refs.relatedRiskFoldIcon.classList.remove('related-risk-box-fold-icon-hidden')
      // } else {
      //   this.$refs.relatedRisk.classList.add('related-risk-box-hidden')
      //
      //   this.foldIcon = 'el-icon-d-arrow-right'
      //   this.$nextTick(()=>{
      //     this.$refs.relatedRiskFoldIcon.classList.add('related-risk-box-fold-icon-hidden')
      //   })
      //
      // }
    },
    /**
     * 相关企业图谱
     */
    getGraphCompanyData () {
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.getRelationMapProject({id: this.$route.query.key, conceptId: '4', tag: '1'}).then(res => {
        console.log('图谱', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.graphCompanyData.graph = res.result
        }
      })
    },
    /**
     * 相关行业图谱
     */
    getGraphIndustryData () {
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.getRelationMapProject({id: this.$route.query.key, conceptId: '3', tag: '1'}).then(res => {
        console.log('图谱', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.graphIndustryData.graph = res.result
        }
      })
    },
    /**
     * 相关项目图谱
     */
    getGraphProjectData () {
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.getRelationMapProject({id: this.$route.query.key, conceptId: '6', tag: '1'}).then(res => {
        console.log('图谱', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.graphProjectData.graph = res.result
        }
      })
    },
    gotoInfoDetail (row) {
      if (!row.articleStatus) {
        console.log('当前资讯未发布，无法跳转详情页')
        return
      }
      this.$router.push({
        name: 'pbrInfoDetail',
        params: row,
        query: {key: row.articleId}
      })
    },
    riskModel (name) {
      return this.riskModels.filter(r => r.name === name)[0]
    },
    gotoRisk (riskName) {
      let risk = this.riskModel(riskName)
      if (this.riskModelsNameArray.includes(riskName)) {
        // this.$router.push({
        //   name: 'pbrInfo',
        //   query: {key: risk.countryId, n: this.info.country, tKey: risk.id, tn: risk.name, tabPath: 'r'}
        // })
        var currentModuleTags = [{
          id: risk.countryId ,title: this.info.country, type: "country"
        },{
          id: risk.id, title: risk.name, type: "category"
        }];
        this.$router.push({
            name: "pbrInfo",
            params: {
              currentModuleTags,
              tabPath:'fxsj'
            }
          })
      }
    },
    milestonClass (index) {
      if (index < this.maxMilestonIndex) {
        return ['finish']
      } else if (index === this.maxMilestonIndex) {
        return ['in-processing']
      } else {
        return ['not-processing']
      }

    },
    /**
     * 获取操作历史记录，此接口弃用
     */
    fetchProjectHistoryOptionsList () {
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.fetchProjectHistoryOptionsList({projectId: this.this.$route.query.key}).then(res => {
        if (res.success) {
          this.tableData = res.result
        }
      })
    },
    getMileStoneTime (mileStoneName) {
      let obj = {
        'WinningtheBid':'ProjectWinning',
        'ContractSigning':'ContractSigning',
        'StartofProject':'ProjectStarts',
        'StageAcceptance':'StageAcceptance',
        'ProjectCompletion':'ProjectCompletion'
      }, filterName = mileStoneName;
      if (localStorage.getItem('locale').toUpperCase() === 'EN'){
        filterName = obj[mileStoneName.replace(/ /g, '')]
      }

      let filter = this.milestonModels.filter(m => m.event === filterName)
      if (filter.length > 0) {
        return filter[0]['time']
      }
      return ''
    },
    exportDetail () {
      // let form = $(this.$refs.submitForm).find('form')
      // form.find('input[name=\'id\']').val(this.$route.query.key)
      // form.submit()
      exportFile(this.action, {id: this.$route.query.key}, this.$t('label.export.project') + this.info.title, contentType.word, '.docx')
    },
    fetchProjectDetail () {
      this.$pbrApis.fetchProjectDetail({id: this.$route.query.key, from: 'cn'}).then((res) => {
        console.log('基本信息', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.code === 200) {
          if(res.result.infoModel.buildOrganizationId){
            this.$pbrApis.fetchEnterpriseByName({keywords: res.result.infoModel.buildOrganization, id: res.result.infoModel.buildOrganizationId}).then(resp => {
              if (resp.success) {
                if (resp.result && resp.result.hasOwnProperty('name') && resp.result.name !== ""){
                  this.contact = resp.result.connectPhone
                }
              }
            })
          }
          this.isBidding = res.result.infoModel.state=='招标'? true : false;
          this.info = res.result.infoModel
          this.historyModels = res.result.historyModels
          this.milestonModels = res.result.milestonModels
        }
      })
    },
    fetchProjectReferensOthers () {
      // 'xm11090067183370240'
      this.$pbrApis.fetchProjectReferensOthers({id: this.$route.query.key, from: 'cn'}).then((res) => {
        console.log('相关法律等', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.adviseModels = res.result.adviseModels
          this.lawModels = res.result.lawModels
          this.policies = res.result.policies
          this.websites = res.result.websites
          this.reportModels = res.result.reportModels
          this.countryRiskModels = res.result.countryRiskModels
        }
      })
    },
    addProjectReadTimes () {
      this.$pbrApis.addProjectReadTimes({id: this.$route.query.key}).then((res) => {
        console.log('增加阅读次数', res)
      })
    },
    fetchProjectReferensInfo () {
      // this.$pbrAxios.post('/front/project/detail', {id: 'xm11090067183370240'}).then((data) => {
      //   this.info = data.result.infoModel
      // })

      this.$pbrApis.fetchProjectReferensInfo({id: this.$route.query.key, from: 'cn'}).then((res) => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          console.log('相关资讯等', res)
          this.businessModels = res.result.businessModels
          this.riskModels = res.result.riskModels
          this.articleModels = res.result.articleModels
        }
      })
    },
    editFavorite () {
      if (!this.$route.query.key) {
        //this.$iMessage.error({content: this.$t('message.warning.noFavorite'), duration: 5})
        return
      }
      let type = this.info.fav ? 'delete' : 'add'
      // this.info.id
      this.$pbrApis.editFavorite(type, {id: this.$route.query.key, type: 3, userId: 1}).then(res => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.favorite'), duration: 5})
        } else if (res.code === 200) {
          console.log('收藏', res)
          // this.$iMessage.success({
          //   content: type === 'add' ? this.$t('message.success.favorite') : this.$t('message.success.unfavored'),
          //   duration: 5
          // })
          this.fetchProjectDetail()
        }
      }).catch(err => {
        //this.$iMessage.error({content: err.message, duration: 5})
      })
    },
    getProjectFileUrl (file) {
      return file.path || file.url || ''
    },
    gotoCompanyDetail (unit, index) {

      if (unit.indexOf('****') > -1) {
        return
      }

      if (!this.info.buildOrganizationId || this.info.buildOrganizationId.split(';').length === 0) {
        this.$router.push({name: 'pbrCompanyDetail', query: {key: undefined, name: unit}})
        return
      }
      this.$router.push({
        name: 'pbrCompanyDetail',
        query: {key: this.info.buildOrganizationId.split(';')[index], name: unit}
      })
    },
    // fetchProjectDetail, fetchProjectReferensInfo, fetchProjectReferensOthers, addProjectReadTimes
    goback () {
      this.$router.back() || window.close()
    }
  },
  watch: {
    '$store.state.brpaModule.theme': {
      immediate: true,
      handler: function (val) {
        /* let theme = val == 'dark' ? 'dark' : 'light'
        init(dom,theme) */
      }
    }
  },
  filters: {
    filterEmpty: function (value) {
      if (!value || value.length === 0) {
        return '--'
      }
      return value
    },
    filterSymbol: (value) => {
      if (value && value.length > 0) {
        return value.replace(/[?？]{2,}/g, '').replace(/\n+/g, '\n').replace(/@Project_Content@/g, '')
      }
      return '--'
    },
    filterTime: (value, vue) => {
      if (value !== '--') {
        return vue.$moment(value).isValid() ? vue.$moment(value).format('yyyy-MM-DD') : value
      }
      return value
    }
  }

}
</script>
<style scoped>
.pbr-project-detail-adv {
  text-indent: 2em;
}
.project-brief{
  white-space: pre-wrap;
  line-height: 1.5;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px 15px;
  background-color: #fafafa;
}
/* .project-detail-contact-hint {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
  font-size: 12px;
  color: #808c9a;
  line-height: 1.6;
}
.project-disclaimer {
  margin-top: 20px;
  padding: 12px 16px;
  background: #fafafa;
  border-left: 3px solid #dcdfe6;
  border-radius: 0 4px 4px 0;
}
.project-disclaimer-title {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  margin-bottom: 8px;
}
.project-disclaimer-content {
  font-size: 12px;
  color: #808c9a;
  line-height: 1.8;
  text-align: justify;
} */
.project-attachments-box {
  align-items: center;
  line-height: 24px;
}
.project-attachments-box /deep/ .el-link {
  line-height: 24px;
  vertical-align: middle;
}
.project-attachments-box /deep/ .ivu-divider-vertical {
  top: 0;
  margin: 0 8px;
  height: 14px;
  vertical-align: middle;
}
/deep/ .ivu-table-tip {
  overflow: hidden;
}
>>> .ivu-avatar-large{
  line-height: normal;
}
>>> .ivu-avatar>img{
  width: 40px;
  height:auto;
}
</style>
